<app-spinner [isLoading]="isLoading"></app-spinner>
<p-toast />

<!-- @if (!hideOwnSearchBar) { -->
<div class="search-bar-container hide-on-print"
  [ngClass]="(itemId && selectedFileName) ? 'justify-content-end search-bar-left' : 'justify-content-center'">
  <!-- <app-search-component [placeHolder]="'Search for an item in DIA'" [isNotFound]="isNotFound"
    (onSearchClick)="onSearchParcel($event)" class="hide-on-print w-full md:w-6 lg:w-6 gap-2" [itemId]="itemId"
    [class.hidden]="!showRightPanel"></app-search-component> -->
</div>
<!-- } -->

<!-- Archived Image Warning Banner -->
@if (isArchived) {
<div class="archived-banner hide-on-print">
  <div class="banner-content">
    <div class="banner-icon">
      <i class="pi pi-exclamation-circle"></i>
    </div>
    <div class="banner-message">
      <h4>Image Archived</h4>
      <p>{{ archiveMessage }}</p>
    </div>
    <div class="banner-action">
      <button pButton type="button" [label]="isSuperUser?'Initiate Retrieval':'Submit Request'"
        (click)="openRetrievalForm()" [disabled]="restoreStatus === 'requested'" class="btn-request"
        [class.btn-disabled]="restoreStatus === 'requested'">
      </button>
      @if (restoreStatus === 'requested') {
      <small class="requested-status">
        Request Already Submitted
      </small>
      }
    </div>
  </div>
</div>
}

<!-- Restoration In Progress Banner -->
@if (restoreStatus === 'restore_requested' && isNormalUser) {
<div class="restoration-banner hide-on-print">
  <div class="banner-content">
    <div class="banner-icon">
      <i class="pi pi-clock"></i>
    </div>
    <div class="banner-message">
      <h4>{{ inProgressHeader }}</h4>
      <p [innerHTML]="inProgressMsg"></p>
    </div>
  </div>
</div>
}
@if(itemId && selectedFileName) {
<div class=" grid hide-on-print main-grid" [class.main-grid-expand]="!showRightPanel">
  <div class="left-panel" [ngClass]="(itemId && selectedFileName) ? 'left-panel-onItem' : ''"
    [class.expand]="!showRightPanel" [class.full-width]="!showRightPanel">
    @if (selectedFileName && viewerActive) {
    <app-file-viewer [fileName]="selectedFileName" [fileUrl]="selectedFileUrl" [itemId]="itemId || ''">
    </app-file-viewer>
    }
  </div>
  @if (itemId && selectedFileName) {
  <button type="button" class="default-max-win toggle-btn" [class.toggle-btn-expand]="!showRightPanel" pInputText
    [pTooltip]="showRightPanel?'Expand':'Collapse'" [tooltipPosition]="showRightPanel?'top':'left'"
    (click)="showRightPanel = !showRightPanel">
    <span [class]="showRightPanel?'pi pi-window-maximize':'pi pi-window-minimize'"></span>
  </button>
  }
  <div class="right-panel" [class.hidden]="!showRightPanel">
    @if (versions.length > 0) {
    <div class="card">
      @if (totalVersions >=6) {
      <div class="">
        <p-paginator [first]="first2" [rows]="rows2" [totalRecords]="totalVersions"
          (onPageChange)="onPageChange($event)" [showCurrentPageReport]="true"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}" [showPageLinks]="false"
          [showFirstLastIcon]="false"></p-paginator>
      </div>
      }
      <p-table [value]="products" dataKey="id" [expandedRowKeys]="expandedRows" size="small">
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 5rem"></th>
            <th>Activity </th>
            <th></th>
            @if (isSuperUser) {
            <th></th>
            }
            <th></th>

          </tr>
        </ng-template>
        <ng-template #body pTemplate="body" let-product let-expanded="expanded">
          <tr>
            <td>
              <p-button type="button" pRipple [pRowToggler]="product" [text]="true" [rounded]="true" [plain]="true"
                [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'" />
            </td>
            <td>{{product.metadata['activity']}}</td>
            <td><p-button label="+ More" (click)="viewDetails(product)" [link]="true" size="small" /></td>
            @if (isSuperUser) {
            <td>
              <p-button type="button" [plain]="true" icon="pi pi-trash" [text]="true" [rounded]="true" severity="danger"
                (click)="onVersionDelete(product)" />
            </td>
            }
            @if (product.processed) {
            <td>
              <span class="ocr-migrated-flag">
                OCR Processed
              </span>
            </td>
            }

          </tr>
        </ng-template>
        <ng-template #expandedrow pTemplate="rowexpansion" let-product>
          <tr>
            <td colspan="7">
              <div class="p-3">
                <p-table showGridlines [value]="product.images" dataKey="id" styleClass="inner-table"
                  [paginator]="product.images.length > 5 ? true: false" [rows]="5" [first]="first"
                  [showCurrentPageReport]="true" size="small"
                  currentPageReportTemplate="Showing {first} to {last} of {totalRecords}">
                  <ng-template #header pTemplate="header">
          <tr>
            <th>Date</th>
            <th>Name</th>
          </tr>
        </ng-template>
        <ng-template #body pTemplate="body" let-image>
          <tr>
            <td style="width: 11rem;">{{ image['imageDateTime'] | formatDateTime: 'return-date' }} {{
              image['imageDateTime'] | formatDateTime: 'return-time' }}</td>
            <td>
              <a href="javascript:void(0)" class="text-to-button truncate-text" (click)="onImageClick($event, image)"
                [class.selected]="selectedFileName == image['imageName']" [pTooltip]=image.imageName
                tooltipPosition="top" [tooltipDisabled]="image.imageName.length < 35">
                {{ image['imageName'] }}
              </a>
            </td>
          </tr>
        </ng-template>
        <ng-template #emptymessage pTemplate="emptymessage">
          <tr>
            <td colspan="6">There are no Images.</td>
          </tr>
        </ng-template>
      </p-table>
      <div class="version-cell" colspan="2">
        <div class="version-wrapper">
          <div class="version-details">
            Version: {{ product.version }}
          </div>
        </div>
      </div>
    </div>
    </td>
    </tr>
    </ng-template>
    </p-table>
    <div>
      @if (barcodeValue) {
      <ngx-barcode6 [bc-format]="'code128'" [bc-value]="barcodeValue" [bc-display-value]="true">
      </ngx-barcode6>
      }
    </div>
    @if (statusData.length > 0) {
    <div class="parcel-status-1">
      <p-fieldset legend="Parcel TimeLine" [toggleable]="true" id="time-line-parcel">
        <div class="status-container">
          <p-timeline [value]="statusData" align="left" styleClass="left-timeline">
            <ng-template pTemplate="marker" let-item>
              <span class="custom-marker" [ngClass]="getStatusClass(item.status)">
                <i [class]="getStatusIcon(item.status)"></i>
              </span>
            </ng-template>
            <ng-template pTemplate="content" let-item>
              <div class="timeline-content">
                <div class="action">
                  @if (item.status === 'reverted') {
                  <span> Reverted by {{item.updater}}
                  </span>
                  }
                  @if (item.status === 'handled') {
                  <span> Finished by {{item.updater}}
                  </span>
                  }
                  @if (item.status === 'assigned') {
                  <span> Assigned to {{item.assignee}} by {{item.updater}}
                  </span>
                  }
                  @if (item.status === 'unassigned') {
                  <span>Unassigned @if (item.updater) {
                    <span>by
                      {{item.updater}}</span>
                    }</span>
                  }
                  @if (item.status === 'reprocessing') {
                  <span>Marked as Reprocessing by {{item.updater}}</span>
                  }
                </div>
                <small class="date">{{item.timestamp | date: 'dd-MM-yyyy HH:mm:ss'}}</small>
              </div>
            </ng-template>
          </p-timeline>
        </div>
      </p-fieldset>
    </div>
    }
  </div>
  }
</div>
</div>
}
<p-confirmDialog>
  <ng-template pTemplate="message" let-message>
    <div class="flex flex-column align-items-center w-full gap-3 surface-border" style="width: 200px;">
      <i class="pi pi pi-times-circle text-6xl text-red-500 mr-2"></i>
      <p>{{ message.message }}</p>
      <div>
        <p-floatLabel>
          <input type="text" id="reason" [(ngModel)]="deleteReason" pInputText style="width: 20rem" required
            #reasonCtrl="ngModel" [ngClass]="((reasonCtrl.invalid && reasonCtrl.touched)) ? 'ng-invalid ng-dirty': ''"
            required minlength="10">
          <label for="reason">Enter Incident number / reason</label>
        </p-floatLabel>
        @if (((reasonCtrl.invalid && reasonCtrl.touched))) {
        <small class="p-error"><strong>
            @if ((deleteReason==null || deleteReason==undefined || deleteReason=='') && reasonCtrl.invalid &&
            reasonCtrl.touched) { * Reason is required
            }@else if(reasonCtrl.invalid && (reasonCtrl.dirty || reasonCtrl.touched) && deleteReason.length <10){ Input
              must be at least 10 characters long. } </strong>
        </small>
        }
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="footer">
    <button pButton label="No" icon="pi pi-times mr-2" class="p-button-sm button-bg" (click)="confirmationService.close()">

    </button>
    <button pButton label="Yes" icon="pi pi-check mr-2" class="p-button-outlined p-button-sm button-bg"
      (click)="onDeleteVersion(currentRow)" [disabled]="!deleteReason || deleteReason.length <10">
    </button>

  </ng-template>
</p-confirmDialog>
<p-dialog header="Parcel Details" [(visible)]="showDialog" [modal]="true" id="more-detail" draggable="false">
  @if (selectedParcel) {
  <div>
    <p-table showGridlines [value]="selectedProduct" [style]="{'width':'100%'}">
      <ng-template pTemplate="header">
        <tr>
          <th colspan="2" style="text-align: center;"> {{itemId}}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-product>
        <tr>
          <td><strong>{{product.field}}</strong></td>
          <td>{{ product.value }}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  }
</p-dialog>

<!-- Retrieval Request Form Dialog -->
<p-dialog id="retrievalDialog" header="Request image Retrieval" [(visible)]="showRetrievalForm" [modal]="true"
  [style]="{width: '500px'}" [styleClass]="'retrieval-dialog'" draggable="false" [closable]="!retrievalFormLoading">
  <div class="retrieval-form">
    <div class="form-group">
      <label for="itemIdField">Item ID</label>
      <input type="text" id="itemIdField" pInputText [value]="itemId" readonly class="w-full p-2 readonly-input">
      <!-- <small class="help-text">This is the archived image identifier</small> -->
    </div>

    <div class="form-group mt-3">
      <label for="reasonField">Reason for Retrieval *</label>
      <textarea id="reasonField" pInputTextarea [(ngModel)]="retrievalReason" rows="5"
        [class.ng-invalid]="!isRetrievalFormValid() && retrievalReason !== ''" [class.ng-dirty]="retrievalReason !== ''"
        [disabled]="retrievalFormLoading" class="w-full p-2"
        placeholder="Please explain why you need to retrieve this archived images">
              </textarea>
      <small class="help-text">Minimum 10 characters required</small>
      @if (retrievalReason && retrievalReason.trim().length < 10 && retrievalReason.trim().length> 0) {
        <small class="p-error">
          Please provide a valid reason for retrieval (minimum 10 characters).
        </small>
        }
    </div>

    <!-- Info message for normal users -->
    @if (!isSuperUser) {
    <div class="form-info-message">
      <i class="pi pi-info-circle"></i>
      <div class="message-content">
        <p>Your request will be forwarded to <strong>{{isNormalUser?'reklamation.se&#64;postnord.com':'admin'}}</strong>
          for review and processing.
        </p>
      </div>
    </div>
    }
    @if (!isSuperUser) {
    <div class="form-info-message">
      <i class="pi pi-info-circle"></i>
      <div class="message-content">
        <p>The image can be accessed for up to <strong>10 days</strong> after retrieval.</p>
      </div>
    </div>
    }
  </div>

  <ng-template pTemplate="footer">
    <!-- <button pButton type="button" label="Cancel" icon="pi pi-times"
          (click)="closeRetrievalForm()"
          [disabled]="retrievalFormLoading"
          class="p-button-text">
        </button> -->
    <button pButton type="button" [label]="isSuperUser?'Initiate Retrieval':'Submit Request'" icon="pi pi-check"
    class="button-bg"
      (click)="submitRetrievalRequest()" [disabled]="!isRetrievalFormValid() || retrievalFormLoading"
      [loading]="retrievalFormLoading">
    </button>
  </ng-template>
</p-dialog>